import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface FleetVehicleReturn {
  agreementNumber: string;
  endDate: string;
  authorizedReturnLocationIds: string[];
}

interface FleetState {
  vehicleReturn: FleetVehicleReturn | null;
}

const initialState: FleetState = {
  vehicleReturn: null,
};

const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {
    setFleetVehicleReturn: (state, action: PayloadAction<FleetVehicleReturn | null>) => {
      state.vehicleReturn = action.payload;
    },
  },
});

export const { setFleetVehicleReturn } = fleetSlice.actions;

export default fleetSlice.reducer;
